<template>
	<div class="my-0 py-0 d-flex align-items-center justify-content-center">
		<b-spinner small v-if="loading" class="mt-2" variant="primary"></b-spinner>
		<div v-else-if="error" :class="`text-uppercase costs-td mt-2 ${pClass}`">
			<slot />
		</div>
		<p v-else class="text-danger">---------</p>
	</div>
</template>

<script>
export default {
	props: {
		loading: Boolean,
		error: Boolean,
		danger: Boolean,
		success: Boolean
	},
	computed: {
		pClass() {
			if (this.danger) return "text-danger";
			if (this.success) return "text-success";
			return "";
		}
	}
};
</script>
<style scoped>
.costs-td {
	min-width: 120px;
}
</style>
